<template>
  <div class="second-navs tw-flex tw-rounded-[10px] tw-my-[16px] tw-mx-[10px] tw-select-none">
    <NavIList :nav-list="config.displays.ads.slice(0, 5)" >
      <NavLink
        class="btn-more"
        :nav="{
          text: 'ALL',
          image: themeImages.navMoreIcon
        }"
        @click="handleExpand"
      />
    </NavIList>

    <VPopup
      v-model="visible"
      class="m-second-navs-panel"
      type="popup-right"
      @close="onClose"
    >
      <template #close>
        <button @click="onClose" class="tw-absolute tw-rounded-full tw-bg-[#222] tw-w-[22px] tw-h-[22px] tw-top-[45px] tw-right-[16px]">
          <img :src="themeImages.closeIcon" width="12px" height="12px">
        </button>
      </template>

      <keep-alive>
        <NavPane
          v-if="visible"
          :displays="config.displays"
          :games="config.games"
          :others="config.others"
        />
      </keep-alive>
    </VPopup>
  </div>
</template>

<script>
import VPopup from 'fe-vui/popup'
import modalHelper from '@ms/utils/scroll-fixed'
import NavIList from './NavIList'
import NavLink from './NavLink'
import { useThemeImages } from 'composables/useThemeImages'

export default {
  name: 'SecondNavs',
  components: {
    VPopup,
    NavIList,
    NavPane: () => import(/* webpackPrefetch: true, webpackChunkName: 'pane-navs' */ './NavPane'),
    NavLink
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const themeImages = useThemeImages({
      dark: {
        default: {
          navMoreIcon: require('public/images/icon/nav-more.png'),
          closeIcon: require('../../images/close-icon.png')
        }
      },
      light: {
        default: {
          navMoreIcon: require('public/images/icon/nav-more[light-default].png'),
          closeIcon: require('../../images/close-icon[light-default].png')
        }
      }
    })

    return {
      themeImages
    }
  },
  data() {
    return {
      visible: false
    }
  },
  beforeDestroy() {
    modalHelper.beforeClose()
  },
  methods: {
    handleExpand() {
      this.visible = true
      modalHelper.afterOpen()
      window.mstrace('Home_SubTab_More')
    },
    onClose() {
      modalHelper.beforeClose()
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.second-navs {
  background: #161616;

  .m-second-navs-panel {
    z-index: 2000;

    ::v-deep .popup-wrap {
      overflow: auto;
      width: calc(331/375*100%);
      max-width: 600px;
      background: #121212;
    }
  }
}

[data-mode="light"] .second-navs {
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(0,0,0,7%);

  .m-second-navs-panel {
    ::v-deep .popup-wrap {
      background: #f5f5f5;

      & > .close-btn {
        background: #fff;
      }
    }
  }
}
</style>
